import { createDrawingObject, appendPoint } from "../shared";
const Highlighter = {
    name: "highlighter",
    createDraft: (startPoint) => createDrawingObject("highlighter", [startPoint]),
    updateDraft: (draft, nextPoint) => appendPoint(draft, nextPoint),
    render: () => undefined,
};
export default Highlighter;
